export const buttonBase = {
    borderWidth: 0,
    backgroundColor: 'transparent',
    backgroundImage: 'none',
    cursor: 'pointer',
};
//# sourceMappingURL=base.js.map